import api from './api';

export interface DevLogEntry {
  id: string;
  version: string;
  title: string;
  description: string;
  category: string;
  category_display: string;
  release_date: string;
  created_at: string;
}

export interface DevLogResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: DevLogEntry[];
}

export const devlogService = {
  async getDevLogs(page: number = 1): Promise<DevLogResponse> {
    const response = await api.get<DevLogResponse>(`/audit/devlogs/?page=${page}`);
    return response.data;
  },
};
